/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Status_300Inputs */

const vi_carrier_status_300 = /** @type {(inputs: Carrier_Status_300Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khai thác đi`)
};

/**

* @param {Carrier_Status_300Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_status_300 = /** @type {((inputs?: Carrier_Status_300Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Status_300Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_status_300(inputs)
});